import React, { useId } from 'react';
import { formControlClass, formLabelClass } from './fieldStyles';

export const Textarea = ({
  label,
  error,
  hint,
  rows = 4,
  className = '',
  id,
  ...props
}) => {
  const uid = useId().replace(/:/g, '');
  const { id: idFromProps, ...restProps } = props;
  const inputId = id ?? idFromProps ?? (label ? `fld-${uid}` : undefined);

  return (
    <div className="w-full">
      {label && (
        <label htmlFor={inputId} className={formLabelClass}>
          {label}
        </label>
      )}
      <textarea
        id={inputId}
        rows={rows}
        className={formControlClass({ error: Boolean(error), className: `resize-y ${className}`.trim() })}
        aria-invalid={error ? true : undefined}
        {...restProps}
      />
      {error ? (
        <p className="mt-1.5 text-sm text-rose-600" role="alert">{error}</p>
      ) : hint ? (
        <p className="mt-1.5 text-xs text-slate-500">{hint}</p>
      ) : null}
    </div>
  );
};

export default Textarea;
